import Navigation from "@/components/navigation";
import Footer from "@/components/footer";
import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { apiPost } from "@/lib/api";

export default function SellPage() {
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [form, setForm] = useState({
		firstName: "",
		lastName: "",
		email: "",
		phone: "",
		address: "",
		city: "",
		state: "FL",
		zip: "",
		propertyType: "",
		beds: "",
		baths: "",
		sqft: "",
		timeframe: "",
		reason: "",
		notes: "",
	});

	const handleChange = (key: string, value: string) => setForm(prev => ({ ...prev, [key]: value }));

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setIsSubmitting(true);
		try {
			const payload = {
				firstName: form.firstName,
				lastName: form.lastName,
				email: form.email,
				phone: form.phone,
				message: `Sell Inquiry\nAddress: ${form.address}, ${form.city}, ${form.state} ${form.zip}\nType: ${form.propertyType} | Beds: ${form.beds} | Baths: ${form.baths} | Sqft: ${form.sqft}\nTimeframe: ${form.timeframe}\nReason: ${form.reason}\nNotes: ${form.notes}`,
				propertyId: "sell-inquiry",
				leadType: "sell",
			};
			await apiPost('/api/leads', payload);
			alert('Thanks! We\'ll reach out shortly.');
			setForm({
				firstName: "", lastName: "", email: "", phone: "",
				address: "", city: "", state: "FL", zip: "",
				propertyType: "", beds: "", baths: "", sqft: "",
				timeframe: "", reason: "", notes: "",
			});
		} catch (err) {
			alert('There was an issue. Please try again.');
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<div className="min-h-screen bg-white">
			<Navigation />
			<div className="bg-gradient-to-r from-ocean-blue to-bright-blue text-white py-12">
				<div className="max-w-7xl mx-auto px-4">
					<h1 className="font-playfair text-4xl font-bold">Sell Your Waterfront Home</h1>
					<p className="opacity-90 mt-2">Tell us about your property and selling goals.</p>
				</div>
			</div>

			<div className="max-w-4xl mx-auto p-4 md:p-8">
				<form onSubmit={handleSubmit} className="space-y-8 bg-gray-50 rounded-2xl p-6 md:p-8 border">
					<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
						<div>
							<Label>First Name</Label>
							<Input value={form.firstName} onChange={(e) => handleChange('firstName', e.target.value)} required />
						</div>
						<div>
							<Label>Last Name</Label>
							<Input value={form.lastName} onChange={(e) => handleChange('lastName', e.target.value)} required />
						</div>
						<div>
							<Label>Email</Label>
							<Input type="email" value={form.email} onChange={(e) => handleChange('email', e.target.value)} required />
						</div>
						<div>
							<Label>Phone</Label>
							<Input type="tel" value={form.phone} onChange={(e) => handleChange('phone', e.target.value)} required />
						</div>
					</div>

					<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
						<div className="md:col-span-2">
							<Label>Property Address</Label>
							<Input value={form.address} onChange={(e) => handleChange('address', e.target.value)} required />
						</div>
						<div>
							<Label>City</Label>
							<Input value={form.city} onChange={(e) => handleChange('city', e.target.value)} required />
						</div>
						<div>
							<Label>State</Label>
							<Input value={form.state} onChange={(e) => handleChange('state', e.target.value)} />
						</div>
						<div>
							<Label>ZIP</Label>
							<Input value={form.zip} onChange={(e) => handleChange('zip', e.target.value)} />
						</div>
					</div>

					<div className="grid grid-cols-1 md:grid-cols-4 gap-4">
						<div>
							<Label>Property Type</Label>
							<Input placeholder="Single Family, Condo..." value={form.propertyType} onChange={(e) => handleChange('propertyType', e.target.value)} />
						</div>
						<div>
							<Label>Beds</Label>
							<Input value={form.beds} onChange={(e) => handleChange('beds', e.target.value)} />
						</div>
						<div>
							<Label>Baths</Label>
							<Input value={form.baths} onChange={(e) => handleChange('baths', e.target.value)} />
						</div>
						<div>
							<Label>Sq Ft</Label>
							<Input value={form.sqft} onChange={(e) => handleChange('sqft', e.target.value)} />
						</div>
					</div>

					<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
						<div>
							<Label>Timeframe to Sell</Label>
							<Input placeholder="e.g., 0-3 months, 3-6 months" value={form.timeframe} onChange={(e) => handleChange('timeframe', e.target.value)} />
						</div>
						<div>
							<Label>Why are you selling?</Label>
							<Input placeholder="Relocating, upgrading, investment, etc." value={form.reason} onChange={(e) => handleChange('reason', e.target.value)} />
						</div>
					</div>

					<div>
						<Label>Anything else we should know?</Label>
						<Textarea rows={5} value={form.notes} onChange={(e) => handleChange('notes', e.target.value)} />
					</div>

					<div className="flex justify-end">
						<Button type="submit" disabled={isSubmitting} className="bg-ocean-blue hover:bg-bright-blue text-white">
							{isSubmitting ? 'Submitting…' : 'Request Consultation'}
						</Button>
					</div>
				</form>
			</div>

			<Footer />
		</div>
	);
}
